import { post, get } from './http.api';
import {
  Parameters,
  ProductTableRow,
  ProductTableData,
  ProductResponse,
  ProductApiData,
} from '@app/models/products/ProductResponse';
import { ProductRequest } from '@app/models/products/ProductRequest';

export const getProductTableData = async (parameters: Parameters): Promise<ProductTableData> => {
  try {
    const { data, status } = await get<any>('products', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const products: ProductTableRow[] = data.data.map((productData: any) => ({
      id: productData.id,
      product_category: productData.product_category ? productData.product_category : { id: null, name: '-' },
      code: productData.code,
      name: productData.name,
    }));

    return {
      data: products,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
      status_options: data.status_options,
      product_categories: data.product_categories,
    };
  } catch (error: any) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getAllProducts = async (): Promise<ProductResponse> => {
  try {
    const { data, status } = await get<ProductResponse>(`products`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getProductById = async (id: number): Promise<ProductResponse> => {
  try {
    const { data, status } = await get<ProductResponse>(`products/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeProduct = async (productData: ProductRequest) => {
  try {
    const response = await post<any>('products/create', productData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createProduct = async (): Promise<ProductApiData> => {
  try {
    const { data, status } = await get<ProductApiData>(`products/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showProduct = async (id: number) => {
  try {
    const { data, status } = await get<ProductApiData>(`products/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editProduct = async (id: number) => {
  try {
    const { data, status } = await get<ProductApiData>(`products/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateProduct = async (id: number, Updatecategory: ProductRequest) => {
  try {
    const { data, status } = await post<ProductRequest>(`products/${id}/edit`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
